import { render, staticRenderFns } from "./Comment4video.vue?vue&type=template&id=018a1dad&scoped=true"
import script from "./Comment4video.vue?vue&type=script&lang=js"
export * from "./Comment4video.vue?vue&type=script&lang=js"
import style0 from "./Comment4video.vue?vue&type=style&index=0&id=018a1dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a1dad",
  null
  
)

export default component.exports